/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


const settlementTimeSectionStyle = {
  timeSection: {
    textAlign: "center",
  },
  headline: {
    color: "primary.main",
  },
  subHeadline: {
    paddingTop: "1rem",
    color: "primary.main",
  },
};

export default settlementTimeSectionStyle;
